import {combineReducers} from 'redux';
import updateaccount from './updateaccount/reducer';
import personalprofile from './personalprofile/reducer';

export default combineReducers({
  updateaccount,
  personalprofile,
});
